var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoBriefcase01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40.8 40.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.8,
    height: 40.8,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -0.0001,
    width: 40.8,
    height: 40.8,
    rx: 8,
    ry: 8,
    fill: "#f2642a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.2362,30.4365H9.6982c-.355,0-.645-.29-.645-.645v-8.793c3.21.981,6.528,1.562,9.881,1.73v1.405c0,.286.231.518.518.518h3.031c.286,0,.518-.232.518-.518v-1.405c3.352-.168,6.67-.749,9.88-1.73v8.793c0,.355-.289.645-.645.645m-10.271-8.234c-.001.016-.002.033-.001.05,0,.002.001.005.001.008v1.355h-1.995v-2.709h1.995v1.296Zm-12.267-7.781h22.538c.356,0,.645.289.645.645v4.847c-3.206,1.008-6.525,1.605-9.88,1.777v-1.302c0-.286-.232-.518-.518-.518h-3.031c-.287,0-.518.232-.518.518v1.302c-3.356-.172-6.675-.769-9.881-1.777v-4.847c0-.356.29-.645.645-.645m6.186-3.218c0-.463.377-.84.839-.84h8.488c.463,0,.839.377.839.84v2.182h-10.166v-2.182Zm16.352,2.182h-5.15v-2.182c0-1.034-.841-1.876-1.875-1.876h-8.488c-1.033,0-1.875.842-1.875,1.876v2.182h-5.15c-.927,0-1.681.754-1.681,1.681v14.725c0,.927.754,1.681,1.681,1.681h22.538c.927,0,1.681-.754,1.681-1.681v-14.725c0-.927-.754-1.681-1.681-1.681",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBriefcase01);
export default __webpack_public_path__ + "static/media/ico-briefcase-01.460252a494574d4ff781d68b4c32240e.svg";
export { ForwardRef as ReactComponent };